export default {
  setStatus (state, status) {
    state.isActivated = status.activated || false
  }
}
